import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const categoryImages = [
  {
    slug: 'yule-mingxing',
    src: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20flashing%20paparazzi%20cameras%2C%20elegant%20celebrities%20silhouettes%2C%20warm%20golden%20lighting%2C%20glamorous%20atmosphere%2C%20editorial%20fashion%20photography%20style%2C%20luxurious%20red%20and%20gold%20aesthetic%2C%20soft%20focus%20background&width=400&height=300&seq=cat-yule&orientation=landscape',
  },
  {
    slug: 'wanghong-zhubo',
    src: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20studio%20with%20ring%20light%20and%20professional%20camera%20setup%2C%20smartphone%20on%20tripod%2C%20colorful%20neon%20accents%2C%20warm%20ambient%20lighting%2C%20social%20media%20aesthetic%2C%20clean%20minimalist%20desk%20setup%2C%20soft%20warm%20tones&width=400&height=300&seq=cat-wanghong&orientation=landscape',
  },
  {
    slug: 'shehui-redian',
    src: 'https://readdy.ai/api/search-image?query=Breaking%20news%20concept%20with%20newspaper%20headlines%20overlapping%2C%20dramatic%20warm%20lighting%2C%20journalism%20theme%2C%20editorial%20photography%20style%2C%20golden%20hour%20glow%2C%20abstract%20newsroom%20atmosphere%2C%20professional%20documentary%20feel&width=400&height=300&seq=cat-shehui&orientation=landscape',
  },
  {
    slug: 'dianshi-zongyi',
    src: 'https://readdy.ai/api/search-image?query=TV%20studio%20production%20set%20with%20dramatic%20stage%20lighting%2C%20professional%20broadcast%20cameras%2C%20warm%20cinematic%20atmosphere%2C%20entertainment%20show%20vibe%2C%20golden%20spotlights%2C%20behind%20the%20scenes%20feel%2C%20editorial%20quality&width=400&height=300&seq=cat-zongyi&orientation=landscape',
  },
  {
    slug: 'dujia-bagua',
    src: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20theme%20with%20magnifying%20glass%20and%20documents%2C%20warm%20amber%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20shadows%2C%20film%20noir%20inspired%2C%20soft%20candlelight%20glow%2C%20elegant%20mysterious%20atmosphere&width=400&height=300&seq=cat-dujia&orientation=landscape',
  },
  {
    slug: 'hulianwang',
    src: 'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20with%20computer%20servers%20and%20digital%20screens%2C%20warm%20ambient%20lighting%2C%20cyber%20aesthetic%2C%20data%20visualization%2C%20professional%20corporate%20atmosphere%2C%20golden%20and%20amber%20color%20scheme%2C%20clean%20modern%20design&width=400&height=300&seq=cat-internet&orientation=landscape',
  },
];

export default function CategorySection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-medium text-secondary-600 uppercase tracking-widest">
            热门频道
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-heading text-foreground-950">
            全网爆料分类
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat, idx) => {
            const img = categoryImages.find((i) => i.slug === cat.slug);
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={img?.src || ''}
                    alt={cat.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute top-4 left-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                    <i className={`${cat.icon} text-white text-lg`}></i>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}